import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import share1 from "../Image/share1.png";
import share2 from "../Image/share2.png";
import trending from "../Image/trending.png";
import { SlCalender } from "react-icons/si";
import calender from "../Image/calender.png";
import download from "../Image/download.png";
import { Dropdown } from "react-bootstrap";
function PriceChart({ api, staticPrice = 1, staticTotalSupply = 100000000 }) {
  const [chartData, setChartData] = useState([]);
  const [h_24, seth_24s] = useState(1);
  const [var_price, setvar_prices] = useState("prices");
  const [price_name, setprice_names] = useState("price");

  const chartOptions = {
    chart: {
      id: "zoomable-chart",
      type: "area",
      height: 350,
      zoom: {
        enabled: true,
      },
      toolbar: {
        autoSelected: "zoom",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `$${value.toFixed(2)}`;
        },
      },
      opposite: true,
    },
    tooltip: {
      x: {
        format: "dd MMM yyyy",
      },
    },
  };

  const currentTime = new Date().getTime();

  useEffect(() => {
    // If no API provided, generate a static flat series for RUSD
    if (!api) {
      const now = Date.now();
      const msPerDay = 24 * 60 * 60 * 1000;
      let spanDays = 30;
      if (h_24 === 1) spanDays = 1;
      else if (h_24 === 7) spanDays = 7;
      else if (h_24 === 30) spanDays = 30;
      else if (h_24 === 365) spanDays = 365;
      else if (h_24 === 1825) spanDays = 1825;
      else if (h_24 === "max") spanDays = 3650;

      // Points to render based on timeframe (keep it reasonable)
      let points = 30;
      if (h_24 === 1) points = 24;
      else if (h_24 === 7) points = 7;
      else if (h_24 === 30) points = 30;
      else if (h_24 === 365) points = 52;
      else if (h_24 === 1825) points = 60;
      else if (h_24 === "max") points = 100;

      const spanMs = spanDays * msPerDay;
      const interval = Math.max(1, Math.floor(spanMs / points));
      const value =
        var_price === "prices"
          ? Number(staticPrice)
          : Number(staticPrice) * Number(staticTotalSupply);

      const formattedData = Array.from({ length: points }).map((_, i) => ({
        x: now - (points - 1 - i) * interval,
        y: value,
      }));

      setChartData([{ name: price_name, data: formattedData }]);
      return;
    }

    // Fetch data from API and update chartData state
    fetch(`${api}${h_24}`)
      .then((response) => response.json())
      .then((data) => {
        // Determine which property to access dynamically based on var_price
        const propertyToAccess =
          var_price === "prices" ? "prices" : "market_caps";

        // Process the fetched data and format it for the chart
        const formattedData = data[propertyToAccess].map(
          ([timestamp, value]) => ({
            x: timestamp,
            y: value,
          }),
        );
        setChartData([{ name: price_name, data: formattedData }]);
      })
      .catch((error) => console.log(error));
  }, [h_24, var_price, api, staticPrice, staticTotalSupply]);
  // remaining UI controls and render below

  return (
    <div>
      <div className="m-q-d-f flex-wrap  a-i-c  c-p">
        <div className="m-q-m-r-1 m-b-1  b-r-5">
          <div className="d-f a-i-c j-c-s-e pa-5rem bg_g_clr b-r-5">
            <div
              className={`w-7 t-a-c ${
                var_price == "prices" ? "bg_d_b_clr b-r-5 pa-5rem" : ""
              } `}
              onClick={() => setvar_prices("prices")}
            >
              Price
            </div>
            <div
              className={`w-7 t-a-c ${
                var_price == "market_caps" ? "bg_d_b_clr b-r-5 pa-5rem" : ""
              } `}
              onClick={() => setvar_prices("market_caps")}
            >
              Market Cap
            </div>
          </div>
        </div>
        {/*     <div className="m-r-1  pa-5rem  b-r-5">
          <div className="d-f a-i-c pa-5rem bg_g_clr b-r-5">
            <div className="pa-5rem bg_d_b_clr b-r-5 m-r-0_5">
              <img src={share1} alt="" className="w-1" />{" "}
            </div>
            <div className="pa-5rem">
              <img src={share2} alt="" className="w-0_5" />{" "}
            </div>
          </div>
        </div> */}
        {/*  <div className="m-r-1 bg_g_clr pa-5rem b-r-5">
          <img src={trending} alt="" className="w-1" /> TradingView{" "}
        </div>
        <div className="m-r-1 ">
          {" "}
          <Dropdown className="pa-5rem bg_g_clr  b-r-5">
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              className="b-c-t b-n c-i "
            >
              Compare with
            </Dropdown.Toggle>

            <Dropdown.Menu className="pa-1">
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div> */}
        <div className="m-q-m-r-1  m-b-1 ">
          <div className="    b-r-5">
            <div className="d-f a-i-c pa-5rem bg_g_clr b-r-5">
              <div
                className={`   ${
                  h_24 == 1 ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                } m-r-0_5  pa-5rem t-a-c `}
                onClick={() => seth_24s(1)}
              >
                1D
              </div>
              <div
                className={`   ${
                  h_24 == 7 ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                } m-r-0_5  pa-5rem t-a-c `}
                onClick={() => seth_24s(7)}
              >
                7D
              </div>
              <div
                className={`   ${
                  h_24 == 30 ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                } m-r-0_5  pa-5rem t-a-c `}
                onClick={() => seth_24s(30)}
              >
                1M
              </div>
              <div
                className={`   ${
                  h_24 == 365 ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                } m-r-0_5  pa-5rem t-a-c `}
                onClick={() => seth_24s(365)}
              >
                1Y
              </div>
              <div
                className={`   ${
                  h_24 == 1825 ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                } m-r-0_5  pa-5rem t-a-c `}
                onClick={() => seth_24s(1825)}
              >
                5Y
              </div>
              <div
                className={`   ${
                  h_24 == "max" ? " t-a-c  bg_d_b_clr b-r-5 " : ""
                }  pa-5rem t-a-c `}
                onClick={() => seth_24s("max")}
              >
                ALL
              </div>
              {/* <div className="p-x-0_5 b-r_1">
                {" "}
                <img src={calender} alt="" className="w-1" />
              </div> */}
              {/* <div className="p-x-0_5 b-r_1">LOG </div> */}
              {/* <div className="p-x-0_5 ">
                <img src={download} alt="" className="w-0_5" />{" "}
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="b-1 b_clr_gray w-100 p-x-1 p-t-1 p-b-2_5 b-r-5">
        <div className="chart">
          <ReactApexChart
            options={chartOptions}
            series={chartData}
            type="area"
            height={350}
          />
        </div>
      </div>
    </div>
  );
}

export default PriceChart;
